module.exports = __webpack_public_path__ + "img/undraw_Images_re_0kll_transparent.0a0e829c.png";